<template>
    <widget :title="title" :router="router" :class="'widget_level'+widgetType">
        <template slot="choose_info">
            <selectCom :tabList="gradeInfos" @getTab="getTerm" v-if="gradeInfos.length > 0" type="grade"></selectCom>
        </template>
        <div class="widget_cont">
            <div class="schedule_left">
                <div class="class_type">
                    <div class="class_list">
                        <span>{{tableData.stuTotalW || 0}}</span>
                        <div class="cont_text_overflow">学生总数</div>
                    </div>
                    <div class="class_list">
                        <span>{{tableData.adminTotalW || 0}}</span>
                        <div class="cont_text_overflow">行政班数</div>
                    </div>
                    <div class="class_list">
                        <span>{{tableData.movingTotalW || 0}}</span>
                        <div class="cont_text_overflow">走班班数</div>
                    </div>
                    <div class="class_list">
                        <span>{{tableData.courseTotalW || 0}}</span>
                        <div class="cont_text_overflow">开课课程数</div>
                    </div>
                </div>
                <div class="table_box">
                    <div class="table_col">
                        <div class="table_th">任课教师总数</div>
                        <div>{{tableData.teaTotalW || 0}}</div>
                    </div>
                    <div class="table_col">
                        <div class="table_th">行政班教师</div>
                        <div>{{tableData.adminTeaW || 0}}</div>
                    </div>
                    <div class="table_col">
                        <div class="table_th">走班教师</div>
                        <div>{{tableData.adminRoomW || 0}}</div>
                    </div>
                    <div class="table_col">
                        <div class="table_th">使用场地总数</div>
                        <div>{{tableData.roomTotalW || 0}}</div>
                    </div>
                    <div class="table_col">
                        <div class="table_th">行政班使用场地</div>
                        <div>{{tableData.adminRoomW || 0}}</div>
                    </div>
                    <div class="table_col">
                        <div class="table_th">走班使用场地</div>
                        <div>{{tableData.movingRoomW || 0}}</div>
                    </div>
                </div>
            </div>
            <el-tabs v-model="activeName" class="schedule_right" @tab-click="handleClick" v-if="widgetType != 1">
                <el-tab-pane label="上课学生数" name="first">
                    <div class="chart_box">
                        <div class="bar_chart" ref="bar_chart" style="width:100%;height:225px;"></div>
                        <template v-if="myChartQuery1.totalPage > 1">
                            <span class="page_btn prev" @click="studentPrev" v-if="myChartQuery1.page > 1 && myChartQuery1.page <= myChartQuery1.totalPage"><i class="el-icon-arrow-left"></i></span>
                            <span class="page_btn next" @click="studentNext" v-if="myChartQuery1.page < myChartQuery1.totalPage"><i class="el-icon-arrow-right"></i></span>
                        </template>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="平均周课时数" name="second">
                    <div class="chart_box">
                        <div class="line_chart"  ref="line_chart" style="width:100%;height:225px;"></div>
                        <template v-if="myChartQuery2.totalPage > 1">
                            <span class="page_btn prev" @click="weekPrev" v-if="myChartQuery2.page > 1 && myChartQuery2.page <= myChartQuery2.totalPage"><i class="el-icon-arrow-left"></i></span>
                            <span class="page_btn next" @click="weekNext" v-if="myChartQuery2.page < myChartQuery2.totalPage"><i class="el-icon-arrow-right"></i></span>
                        </template>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="教学场地" name="third">
                    <div class="chart_box">
                        <div class="bar_chart" ref="third_chart" style="width:100%;height:225px;"></div>
                        <template v-if="myChartQuery3.totalPage > 1">
                            <span class="page_btn prev" @click="teachPrev" v-if="myChartQuery3.page > 1 && myChartQuery3.page <= myChartQuery3.totalPage"><i class="el-icon-arrow-left"></i></span>
                            <span class="page_btn next" @click="teachNext" v-if="myChartQuery3.page < myChartQuery3.totalPage"><i class="el-icon-arrow-right"></i></span>
                        </template>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import selectCom from './select'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget,
            selectCom
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
            item:{
                type:Object
            }
        },
        filters:{
            format:function(val){
                return '.'+val.split('.')[1]
            }
        },
        data(){
            return {
                widgetType:1,
                activeName:'first',
                router:'arrange_scheme_list',
                tabList:[],
                myChart1:null,
                myChart2:null,
                myChart3:null,
                myChartQuery1:{
                    page:1,
                    size:10,
                    totalPage:1
                },
                myChartQuery2:{
                    page:1,
                    size:10,
                    totalPage:1
                },
                myChartQuery3:{
                    page:1,
                    size:10,
                    totalPage:1
                },
                gradeId:'',
                tableData:{
                    gradeInfos:[]
                },
                gradeInfos:[],
                studentNum:[],
                averageWeekNum:[],
                teachRoomNum:[],
                lineChartOption:{
                    color:['#62E6CA'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    grid: {
                        left: '40',
                        right: '10',
                        bottom: '3%',
                        top:'40'
                    },
                    xAxis:  {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {
                        name:'(人数)',
                        type: 'value',
                        axisPointer: {
                            snap: true
                        },
                        axisLine:{
                            lineStyle:{
                                color:"#007BC6"
                            }
                        }
                    },
                    series: [
                        {
                            name:'',
                            type:'line',
                            smooth: true,
                            data: [],
                        }
                    ]
                },
                total:28,
                schoolId:window.appframe.$store.state.userInfo.schoolId,
                campusId:window.appframe.$store.state.userInfo.campusId
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                 vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    vm.widgetUrl = stemp[0].apiUrl
                    vm.querySelect()
                }
            })
        },
        methods:{
            querySelect(){
                let vm = this
                if(vm.schoolId != '' && vm.campusId != ''){
                    let obj = {
                        schoolId:vm.schoolId,
                        campusId:vm.campusId,
                        gradeId:''
                    }
                    http.get('/gateway/arrange-course/widget/arrangeDate',{params:obj}).then(function(xhr){
                        xhr.data.gradeInfos.unshift({gradeName:'全部',id:''})
                        vm.gradeInfos = xhr.data.gradeInfos
                        vm.query()
                    })
                }
            },
            query(){
                let vm = this
                if(vm.schoolId != '' && vm.campusId != ''){
                    let obj = {
                        schoolId:vm.schoolId,
                        campusId:vm.campusId,
                        gradeId:vm.gradeId
                    }
                    http.get('/gateway/arrange-course/widget/arrangeDate',{params:obj}).then(function(xhr){
                        let objectA = xhr.data
                        let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                        var newObj = new Object();
                        vm.tableData = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                        // console.log("----------------",vm.tableData)
                        vm.total = vm.tableData.echartData.length
                        vm.studentNum = []
                        vm.averageWeekNum = []
                        vm.teachRoomNum = []
                        _.each(vm.tableData.echartData,function(v){
                            vm.studentNum.push({name:v.courseName,data:v.studentNum})
                            vm.averageWeekNum.push({name:v.courseName,data:v.averageWeekNum})
                            vm.teachRoomNum.push({name:v.courseName,data:v.teachRoomNum})
                        })

                        vm.myChartQuery1.totalPage = Math.ceil(vm.total / vm.myChartQuery1.size)
                        vm.myChartQuery2.totalPage = Math.ceil(vm.total / vm.myChartQuery2.size)
                        vm.myChartQuery3.totalPage = Math.ceil(vm.total / vm.myChartQuery3.size)

                        if(vm.widgetType != 1){
                            vm.studentNumChart()
                            vm.averageWeekNumChart()
                            vm.teachRoomNumChart()
                        }
                    })
                }
            },
            getTerm(data){
                this.gradeId = data.id
                this.query()
            },
            studentNumChart(){
                let vm = this      
                let chartData = vm.splitData(vm.myChartQuery1,vm.studentNum)//分页处理，返回数据        
                vm.myChart1 = echarts.init(vm.$refs["bar_chart"])
                $(window).resize(function(){
                    vm.myChart1.resize();
                })
                let option = _.cloneDeep(vm.lineChartOption)
                    option.xAxis.data = chartData.name
                    option.series[0].data = chartData.data
                    
                vm.myChart1.setOption(option);
                vm.lineChartOption = option
                
            },
            averageWeekNumChart(){
                let vm = this     
                let chartData = vm.splitData(vm.myChartQuery2,vm.averageWeekNum)//分页处理，返回数据
                vm.myChart2 = echarts.init(vm.$refs["line_chart"])
                $(window).resize(function(){
                    vm.myChart2.resize();
                })
                let option = _.cloneDeep(vm.lineChartOption)
                    option.xAxis.data = chartData.name
                    option.series[0].data = chartData.data
                    vm.myChart2.setOption(option);
                    vm.lineChartOption = option
                vm.myChart2.setOption(option)
            },
            teachRoomNumChart(){
                let vm = this     
                let chartData = vm.splitData(vm.myChartQuery3,vm.teachRoomNum)//分页处理，返回数据
                vm.myChart3 = echarts.init(vm.$refs["third_chart"])
                $(window).resize(function(){
                    vm.myChart3.resize();
                })
                let option = _.cloneDeep(vm.lineChartOption)
                    option.xAxis.data = chartData.name
                    option.series[0].data = chartData.data
                    vm.myChart3.setOption(option);
                    vm.lineChartOption = option
                vm.myChart3.setOption(option)
            },
            splitData(params,dataList){
                let page = params.page -1
                let start = page * params.size
                let end = params.page * params.size > this.total ? this.total : params.page * params.size
                let arr = []
                let obj = {
                        name:[],
                        data:[]
                    }
                for(let i=start;i<end;i++){
                    obj.name.push(dataList[i].name)
                    obj.data.push(dataList[i].data)
                }
                return obj
            },
            studentPrev(){
                if(this.myChartQuery1.page > 1){
                    this.myChartQuery1.page--
                    this.studentNumChart()
                }
            },
            studentNext(){
                let page = Math.ceil(this.total / this.myChartQuery1.size)
                if(this.myChartQuery1.page < page){
                    this.myChartQuery1.page++
                    this.studentNumChart()
                }
            },
            weekPrev(){
                if(this.myChartQuery2.page > 1){
                    this.myChartQuery2.page--
                    this.averageWeekNumChart()
                }
            },
            weekNext(){
                let page = Math.ceil(this.total / this.myChartQuery2.size)
                if(this.myChartQuery2.page < page){
                    this.myChartQuery2.page++
                    this.averageWeekNumChart()
                }
            },
            teachPrev(){
                if(this.myChartQuery3.page > 1){
                    this.myChartQuery3.page--
                    this.teachRoomNumChart()
                }
            },
            teachNext(){
                let page = Math.ceil(this.total / this.myChartQuery3.size)
                if(this.myChartQuery3.page < page){
                    this.myChartQuery3.page++
                    this.teachRoomNumChart()
                }
            },
            handleClick(tab, event){
                let vm = this
                setTimeout(function(){
                    if(tab.name == 'first'){
                        vm.myChart1.resize()
                    }else if(tab.name == 'second'){
                        vm.myChart2.resize()
                    }else if(tab.name == 'third'){
                        vm.myChart3.resize()
                    }
                },30)
            }
        }
    }
</script>
<style lang="less" scoped>
    .class_type{
        display: flex;
        margin: 20px -10px 20px 0;
        .class_list{
            width: calc(~'25% - 10px');
            height: 66px;
            margin-left:10px;
            color:#fff;
            border-radius: 6px;
            text-align:center;
            padding-top: 14px;
            span{
                font-weight: bold;
            }
            div{
                margin-top: 2px;
                font-size: 12px;
            }
        }
        .class_list:nth-child(1){
            background:linear-gradient(#3BB7FB,#1965F0);
            background:-webkit-linear-gradient(#3BB7FB,#1965F0);
            background:-o-linear-gradient(#3BB7FB,#1965F0);
            background:-moz-linear-gradient(#3BB7FB,#1965F0);
            margin-left: 0;
        }
        .class_list:nth-child(2){
            background:linear-gradient(#EBEE0E,#F8922D);
            background:-webkit-linear-gradient(#EBEE0E,#F8922D);
            background:-o-linear-gradient(#EBEE0E,#F8922D);
            background:-moz-linear-gradient(#EBEE0E,#F8922D);
        }
        .class_list:nth-child(3){
            background:linear-gradient(#24EAA6,#02CEF1);
            background:-webkit-linear-gradient(#24EAA6,#02CEF1);
            background:-o-linear-gradient(#24EAA6,#02CEF1);
            background:-moz-linear-gradient(#24EAA6,#02CEF1);
        }
        .class_list:nth-child(4){
            background:linear-gradient(#FF76B3,#D234F3);
            background:-webkit-linear-gradient(#FF76B3,#D234F3);
            background:-o-linear-gradient(#FF76B3,#D234F3);
            background:-moz-linear-gradient(#FF76B3,#D234F3);
        }
    }
    .table_box{
        display: flex;
        flex-wrap: wrap;
        border:1px solid #DFE6EC;
        border-bottom: none;
        margin-top: 24px;
        .table_col{
            width: 33.33%;
            div{
                height: 36px;
                line-height: 36px;
                text-align: center;
                border-bottom:1px solid #DFE6EC;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .table_th{
                background:#EDF3FE;
            }
        }
        .table_col:nth-child(2),
        .table_col:nth-child(5){
            border-left: 1px solid #DFE6EC;
            border-right: 1px solid #DFE6EC;
        }
    }
    .widget_level2,
    .widget_level3{
        .widget_cont{
            display: flex;
            .schedule_left{
                width: 50%;
                padding-right: 10px;
            }
            .schedule_right{
                width: 50%;
                padding-left: 10px;
            }
        }
        .chart_box{
            position: relative;
            padding: 0 25px;
            .page_btn{
                position: absolute;
                top:100px;
                width:20px;
                height: 20px;
                border-radius:50%;
                border:1px solid #A6A6A6;
                cursor:pointer;
            }
            .prev{
                left: 0;
            }
            .next{
                right: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/teachingschedule.vue